<template>
  <div class="f-c wrapper">
    <div class="btns-wrapper">
      <el-button type="primary" plain style="width: 100px" size="mini" @click="listAllPictures">Refresh
      </el-button>
    </div>
    <div class="outer-wrapper">
      <div class="">
        <div v-if="pictures.length > 0" class="left-picture-list">
          <div v-for="pic in pictures" :key="pic" :class="{ 'picture-item': true, 'selected': pic === selected }">
            <span class="name" @click="() => selectPicture(pic)">{{ pic }}</span>
            <div class="but-wrapper">
              <div class="delete-icon-wrapper" @click.stop.prevent="() => openConfirm(pic)">
                <svg-icon class="" icon-class="trash" style="font-size: 14px" />
              </div>
              <div class="forward-icon-wrapper" @click.stop.prevent="() => downloadImage(pic)">
                <svg-icon class="" icon-class="forward" style="font-size: 14px" />
              </div>
            </div>
          </div>
        </div>
        <div v-else>No pictures found</div>
      </div>
      <div class="right-picture-wrapper">
        <img id="pallet-picture-display" class="scaled-image" v-if="picture" :src="picture" :height="height"
          width="400" />
      </div>
    </div>

    <confirm-dialog ref="confirm" title="Confirm Delete" :confirmCb="deletePicture" :cancelCb="() => { }"
      :loading="deleteLoading">
      <template v-slot:content>
        <div class="delete-wrapper">
          <span>Are you sure to delete this picture?</span>
          <img height="300" id="pallet-picture-delete-confirm-img" alt="">
        </div>
      </template>
    </confirm-dialog>
  </div>
</template>
<script>
import {
  listPalletPictures,
  getPalletPicture,
  deletePalletPicture
} from '@/api/pallet'
import ConfirmDialog from '@/components/common/Confirm.vue'
import { Message } from 'element-ui'
export default {
  name: 'PalletImage',
  components: { ConfirmDialog },
  props: {
    no: {
      type: String,
      require: true
    }
  },
  data() {
    return {
      picture: null,
      selected: null,
      pictures: [],
      height: 0,
      deleteLoading: false
    }
  },
  methods: {
    openConfirm(pic) {
      this.$refs.confirm.open()
      getPalletPicture(this.no, pic).then(res => {
        const objectURL = URL.createObjectURL(res)
        const img = document.getElementById('pallet-picture-delete-confirm-img')
        img.picture = pic
        img.src = objectURL
      }).catch(error => {
        Message({
          message: 'Failed to get picture, ' + error.message,
          type: 'error',
          duration: 500
        })
        this.$refs.confirm.close()
      })
    },
    selectPicture(pic) {
      if (!pic) return
      this.selected = pic
      getPalletPicture(this.no, pic).then(res => {
        this.picture = URL.createObjectURL(res)
        const img = new Image()
        img.onload = () => {
          this.height = img.naturalHeight / img.naturalWidth * 400
        }
        img.src = this.picture
      }).catch(error => {
        Message({
          message: 'Failed to get picture, ' + error.message,
          type: 'error',
          duration: 500
        })
        this.picture = null
      })
    },
    deletePicture(pic) {
      this.deleteLoading = true
      const img = document.getElementById('pallet-picture-delete-confirm-img')
      const picture = img.picture
      deletePalletPicture(this.no, picture).then(() => {
        Message({
          message: 'Successfully deleted the picture',
          type: 'success',
          duration: 500
        })
        this.listAllPictures()
        if (this.selected === picture) {
          this.selected = null
          this.picture = null
        }
      }).catch(error => {
        Message({
          message: 'failed to delete picture ' + error.message,
          type: 'error',
          duration: 1000
        })
      }).finally(() => {
        this.$refs.confirm.close()
        this.deleteLoading = false
      })
    },
    listAllPictures() {
      listPalletPictures(this.no).then(res => {
        this.pictures = res
      }).catch(error => {
        Message({
          message: 'failed to list pallet pictures ' + error.message,
          type: 'error',
          duration: 1000
        })
        this.pictures = []
      }).finally(() => {
        this.selected = null
        this.picture = null
        this.height = 0
      })
    },
    downloadImage(pic) {
      getPalletPicture(this.no, pic).then(res => {
        const link = document.createElement('a')
        link.download = this.no + '.png'
        link.href = URL.createObjectURL(res)
        // Append the link to the body
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }).catch(error => {
        Message({
          message: 'download picture failed ' + error.message,
          type: 'error',
          duration: 1000
        })
      })
    }
  },
  mounted() {
    this.listAllPictures()
  }
}
</script>
<style scoped lang="scss">
@import 'src/assets/styles/common.scss';

.wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 400px
}

.btns-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.outer-wrapper {
  display: flex;
  flex-direction: row;
  gap: 10px;

  .left-picture-list {
    display: flex;
    flex-direction: column;
    gap: 5px;

    .picture-item {
      font-size: bold;
      // padding: 10px 15px;
      border: 1px solid #ccc;
      border-radius: 5px;
      gap: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      user-select: none;
      cursor: pointer;

      .name {
        padding-left: 15px;
        padding-top: 10px;
        padding-bottom: 10px;
      }

      .but-wrapper {
        display: flex;
        flex-direction: row;
      }

      .delete-icon-wrapper,
      .forward-icon-wrapper {
        padding: 10px 7px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-self: center;
      }

      .delete-icon-wrapper:hover {
        filter: $svg-danger-color;
      }

      .forward-icon-wrapper {
        margin-right: 8px;
        svg {
          font-size: 15px !important;
        }
        rotate: 90deg;

        &:hover {
          filter: $svg-business-color;
        }
      }

      &:hover {
        background-color: #f0f0f0;
      }

      &.selected {
        background-color: #ccc !important;
      }
    }
  }

  .right-picture-wrapper {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-items: center;
    justify-content: center;

    .scaled-image {
      border: 1px solid #ccc;
      border-radius: 5px;
    }
  }
}

.delete-wrapper {
  font-size: 20px;
  display: flex;
  flex-direction: column;
}

#pallet-picture-delete-confirm-img {
  height: auto;
  width: auto;
}
</style>
